module.exports = __webpack_public_path__ + "static/media/new-york-32.62334fe1.jpg";